export default {
    projectName: "mon-language-learning-system",
    appName: "The Mon Language မန်",
    appName2: "The Mon Language: Learning System",
    appVersion: "1.8.4 BETA",
    relatedContents: [
        {
            name: "Mon Calendar",
            author: "Nai Saik Chan",
            description: "Traditional Mon lunar calendar application.",
            alias: "moncalendar",
            link: "https://apps.apple.com/us/app/moncalendar/id6740172947"
        },
        {
            name: "A AR Dictionary",
            author: "Nai Saik Chan",
            description: "Mon - Burmese Dictionary web app developed by Nai Sac Lun.",
            alias: "aarmon",
            link: "https://www.aarmon.app/"
        },
        {
            name: "mondictionary.org",
            author: "Htaw Mon",
            description: "Mon - English Dictionary website developed by Htaw Mon.",
            alias: "mon-dict-htaw",
            link: "https://www.mondictionary.org/"
        },
        {
            name: "Mon Dictionary (iOS/Android)",
            author: "NetScriper",
            description: "Mon - English Dictionary mobile app developed by NetScriper.",
            alias: "mon-dict",
            link: "https://www.youtube.com/watch?v=acRnwk9LvTo"
        },
        {
            name: "Mon English App",
            author: "Ven. Suriya Mon",
            description: "Application that helps user convert from old Mon script system to a more modern Myanmar unicode system.",
            alias: "monengapp",
            link: "https://monenglishapp.web.app/"
        }
    ],
    ourCommunities: [
        {
            name: "Facebook (Official)",
            description: "Official updates, forums and diccussion",
            platform: "facebook",
            link: "https://www.facebook.com/groups/2796857680508438/",
            country: "thai"
        },
        {
            name: "Telegram (Official)",
            description: "Secure messages, dicussion, and sharing",
            platform: "telegram",
            link: "https://t.me/+-o9Lj2pbcvJkOTBl",
            country: "thai"
        },
        {
            name: "Discord (Mon Club)",
            description: "Updates, Discussion, community, and meetings",
            platform: "discord",
            link: "https://discord.gg/vng8SMJXmy",
            //link: "https://discord.gg/GkMD5hVrYv",
            country: "us"
        },
        {
            name: "Twitch (Barnista)",
            description: "Daily live stream on 08.30 PM (UTC+07)",
            platform: "twitch",
            link: "https://www.twitch.tv/barnista27",
            country: "thai"
        },
        {
            name: "YouTube (Barnista)",
            description: "Digital contents and live stream",
            platform: "youtube",
            link: "https://www.youtube.com/@barnista27",
            country: "thai"
        },
        {
            name: "Facebook (Barnista)",
            description: "Barnista's persona Facebook page",
            platform: "facebook",
            link: "https://www.facebook.com/profile.php?id=61574757156088",
            country: "thai"
        },
        {
            name: "Twitter (Barnista)",
            description: "Streaming updates, commentary, and more.",
            platform: "twitter",
            link: "https://x.com/barnista27",
            country: "thai"
        },
        {
            name: "Discord (Barnista)",
            description: "Barnista's Clube: meets and talks.",
            platform: "discord",
            link: "https://discord.gg/GSZeRZaVZb",
            country: "thai"
        },
    ],
    communities: [
        {
            name: "Mon Club",
            alias: "mon-club",
            description: "Next-gen Mon people that saves the civilization.",
            platform: "discord",
            link: "https://discord.gg/vng8SMJXmy",
            country: "mon"
        },
        {
            name: "Mottip E-book (မတ်ဒိဗ်)",
            alias: "monttip",
            description: "ရန်ကဵုလိက်မည်တြေံ ညံင်ဂွုအ် ကၠေံကၠက်တုဲ ကၠောန် မတ်ဒိဗ် EBOOK မဒှ်ရ ။ ကၠောန် ဂွံ ၜိုတ် 400 အုပ်တုဲ ပ္တိုန်ဂွံစရင် ၜိုတ် 600 အုပ်ရ။",
            platform: "telegram",
            link: "https://t.me/mot_tip_ebook",
            country: "mon"
        },
        {
            name: "Mon Youth Community Bangkok (ชมรมเยาวชนมอญกรุงเทพ)",
            alias: "mon-youth-bangkok",
            description: "ဂကောံသၟတ်ဝုတ်ဗၠာ်မန်ဍုၚ်ၜၚ်ကံက်",
            platform: "facebook",
            link: "https://www.facebook.com/monyouthbangkok",
            country: "thai"
        },
        {
            name: 'Mon Youth Forum  (ဌာန်ကောံသၟတ်မန်)',
            alias: "mon-youth-forum",
            description: "Mon Youth Forum is representing a national youth network among the Mon Youth. It is initiated since 2007 during the 1st Mon Youth Seminar.",
            platform: "facebook",
            link: 'https://www.facebook.com/MonYouthForum',
            country: "mon"
        },
        {
            name: 'Mon Lighting Group',
            alias: 'mon-lighting',
            description: 'ဂကောံမန်လျးအရံင် กลุ่มมอญแสงเทียน',
            platform: 'facebook',
            link: 'https://www.facebook.com/MONlightinggroup',
            country: 'thai'
        },
        {
            name: "A Ar (အ အာ)",
            alias: "aar",
            description: "မန်ရီုဗၚ်မန် ကမၠောန်မန် ပရေၚ်ချဳဒရာၚ်မန် ပရိုၚ်မန် သွက်မန်",
            platform: "facebook",
            link: "https://www.facebook.com/www.aar.mon",
            country: "mon"
        },
        {
            name: "လိက်မန် -PDF- Download",
            alias: "leuk-mon-pdf",
            description: "လောကမ္ဂးဂှ် ဒးဒှ်သွက်အဲဟွံသေင်......အဲဟုီမ္ဂးဂှ် ဒးဒှ်သွက်လောကဟေင်ရ",
            platform: "facebook",
            link: "https://www.facebook.com/profile.php?id=100063638662322",
            country: "mon"
        },
        {
            name: "รามัญคดี - MON Studies",
            alias: "mon-study",
            description: "ประวัติศาสตร์มอญ วัฒนธรรมมอญ สังคมมอญ ข่าวสารมอญ ชุมชนมอญ เกร็ดความรู้มอญ เม็ง เตลง รามัญ",
            platform: "facebook",
            link: "https://www.facebook.com/RamannMon",
            country: "thai"
        },
        {
            name: "Mon Khlong Si (มอญคลองสี่)",
            alias: "mon-khlong-si",
            description: "ร่วมรักษาและแพร่ความรู้ ความเข้าใจเกี่ยวกับชาวไทยเชื้อสายมอญ และเผยแพร่วัฒนธรรมพี่น้องมอญ จาก รัฐมอญ",
            platform: "facebook",
            link: "https://www.facebook.com/MONKLONG4",
            country: "thai"
        },
        {
            name: "เรียนภาษามอญ Learning Mon Language",
            alias: "learning-mon-language",
            description: "ศึกษา วิเคราะห์ ภาษาและเรื่องราวประวัติความเป็นมาของมอญ และเผยแพร่ความรู้โดยไม่หวังผลกำไร",
            platform: "facebook",
            link: "https://www.facebook.com/profile.php?id=100063487753229",
            country: "thai"
        },
        {
            name: "The Mon Language Preservation Organization",
            alias: "mlpo",
            description: "initially formed with some like-minded friends in America. With more participants, it took the place of Mon Literature Research Center (MLRC-USA), which was formed in 2005 and of which Nai Sac Lun was the Coordinator.",
            platform: "web",
            link: "https://www.mlpo.org/home/english-language-section/the-formation-of-mlpo/",
            country: "en_us"
        }
    ],
    contributors: [
        {
            name: "Pioneers & Digital Creators",
            role: "",
            link: "",
            country: "ramanndesa",
            members: [
                {
                    name: "Tummanoon Wancha-em (aka. Barnista / ဓမ္မနုည် ဝန်ဇအေမ် / ธรรมนูญ วันชะเอม)",
                    role: "Project Founder, Lead Developer, Mon-Thai descendant.",
                    link: "https://github.com/Barnista",
                    country: "thai"
                },
                {
                    name: "Nai Saik Chan",
                    role: "Co-developer: localization on Burmese-version display language, and dictionary database structure origin.",
                    link: "https://github.com/NaiSaikChan",
                    country: "mon"
                },
                {
                    name: "Ven. Suriya Mon",
                    role: "Co-developer: localization on Mon-version display language.",
                    link: "",
                    country: "us"
                },
                {
                    name: "Ven. Anonta Mon",
                    role: "Co-developer: Mon keyboard layout designer.",
                    link: "https://github.com/anontamon",
                    country: "mon"
                },
                {
                    name: "Htaw Mon",
                    role: "Co-developer: Mon Club's Admin (Discord)",
                    link: "https://github.com/iammon/mon-dictionary",
                    country: "us"
                },
            ]
        },
        {
            name: "Rammanyavivatana (ရာမညာဝိဝဍ္ဎန / กลุ่มรามัญวิวัฒน์) and other Mon-Thai scholars.",
            role: "",
            link: "",
            country: "thai",
            members: [
                {
                    name: "Alongkorn Mon (อลงกรณ์ สุนทรชื่น)",
                    role: "Human Rights Defender on migrant workers of Myanmese-Mon ethnics in Thailand, Former President of Mon Youth Community Bangkok, Thai-Mon descendant.",
                    link: "",
                    country: "thai"
                },
                {
                    name: "Sunthorn Sripanngern (สุนทร ศรีปานเงิน)",
                    role: "Mon Language Fundamental & Guide provider. Dictionary provider, Historian, Linguistic Researcher, Mon native speaker.",
                    link: "",
                    country: "thai"
                },
                {
                    name: "Tirattamar Jiamjuankhao (ธีรัททมาน์ เจียมจวนขาว)",
                    role: "Mon Language Fundamental & Guide provider. Dictionary provider, Mon Linguist, Linguistic Researcher, Legal drafter on Thailand's Ethnic Protection Bill, Thai-Mon descendant. ",
                    link: "",
                    country: "thai"
                },
                {
                    name: "Zuzarz Jaichop (သုည ပညါ)",
                    role: "Independent scholar, Mon language preservationist, author of 'บันทึกความเข้าใจในการหัดอ่านภาษามอญ (လိက်ဂတ်)', Thai-Mon descendant.",
                    link: "",
                    country: "thai"
                },
                {
                    name: "Busaba Prapasapong",
                    role: "Independent scholar, Mon language preservationist, Thai-Mon descendant.",
                    link: "",
                    country: "thai"
                },
                {
                    name: "Manop Kaewyok",
                    role: "Independent scholar, Mon language preservationist, Thai-Mon descendant.",
                    link: "",
                    country: "thai"
                },
            ]
        },
        {
            name: "Academia and other Monland' scholars.",
            role: "",
            link: "",
            country: "mon",
            members: [
                {
                    name: "Mon National College",
                    role: "Academic affiliate, Mon Study and Preservation, and tech fund agent.",
                    link: "",
                    country: "mon"
                },
                {
                    name: "Banya Honsar",
                    role: "Head of Outreach and Mon Ebook Team, Mon National College.",
                    link: "",
                    country: "mon"
                },
                {
                    name: "Ven. Ponnya Non",
                    role: "Tech thinkers, Poetic Mon linguist, buddhist scholar, academic fund agent.",
                    link: "",
                    country: "mon"
                },
                {
                    name: "Gi Mar (aka. Min Salad)",
                    role: "Mon E-book team, Monttip E-book's admin, Buddhist Scholar.",
                    link: "",
                    country: "mon"
                },
            ]
        },
        {
            name: "Monttip E-book (မတ်ဒိဗ်): Community",
            role: "Cultural guidance and validation, Linguistic documents provider",
            link: "https://t.me/mot_tip_ebook",
            country: "mon"
        },
        {
            name: "Mon Club: Community",
            role: "Open discussion and collaboration of Mon youth around the world.",
            link: "https://discord.gg/vng8SMJXmy",
            country: "ramanndesa"
        },
    ],
    honorableMentions: [
        {
            name: "Phra Maha Jaroon Yanajaree and committee members, Wat Chana Songkhram Ratchaworamahawihan, Bangkok, Thailand.",
            role: "Mon-Thai dictionary colpiler.",
            link: "",
            country: "thai"
        },
        {
            name: "Mon Buddhist Student Society, MCU.",
            role: "Society of Mon buddhist studying in Mahachulalongkornrajavidyalaya University, Thailand.",
            link: "",
            country: "ramanndesa"
        },
        {
            name: "Nai Sac Lun",
            role: "Mon-Burmese dictionary compiler (first and second editions).",
            link: "",
            country: "us"
        },
        {
            name: "Nai Tun Way",
            role: "Mon-English dictionary compiler.",
            link: "",
            country: "mon"
        },
        {
            name: "Mon Khlong Si (มอญคลองสี่): Community",
            role: "Cultural guidance and validation, Linguistic accuracy review",
            link: "https://www.facebook.com/MONKLONG4",
            country: "thai"
        },
        {
            name: "เรียนภาษามอญ Learning Mon Language: Community",
            role: "Cultural guidance and validation, Linguistic accuracy review",
            link: "https://www.facebook.com/profile.php?id=100063487753229",
            country: "thai"
        },
        {
            name: "ผศ.บัญญพนต์ พูลสวัสดิ์ (ၜညာဗန် ဘုန်သဝါတ် / Banyapon Poolsawas)",
            role: "Technical & Innovation Advisor",
            link: "https://github.com/banyapon",
            country: "thai"
        },
        {
            name: "Tanapaphon Phoemphunsapphayakon",
            role: "Testing and Feedback",
            link: "",
            country: "thai"
        },
        {
            name: "Sittinon Singmane",
            role: "Testing and Feedback",
            link: "",
            country: "thai"
        },
    ],
    references: [
        {
            name: "Sunthorn Sripanngern. (n.d.). Facebook post regarding Mon consonants",
            date: "2025, Nov 18",
            site: "Facebook post",
            link: "https://www.facebook.com/jakkasiha.sripanngern/posts/pfbid0mxjNwnzaVyCuNeXN7r2wxyoetqWi6iknaamf97NMABBxos7fhP3CmvsbPmPrEdtXl"
        },
        {
            name: "Phra Mahajaroon. แบบเรียนภาษามอญ (ဗီုကတ်ဘာသာမန်)",
            date: "1997",
            site: "...",
            link: "https://drive.google.com/file/d/15s9o47OgTZh-VaMuVCD1k9VKfZIbMaWp/view?usp=sharing"
        },
        {
            name: "ตัวเลขมอญ",
            date: "2025, Sep 9",
            site: "Wikipedia",
            link: "https://th.wikipedia.org/wiki/ตัวเลขมอญ"
        },
        {
            name: "Mon numbers",
            date: "2025, Sep 9",
            site: "Omniglot",
            link: "https://www.omniglot.com/language/numbers/mon.htm"
        },
        {
            name: "บันทึกความเข้าใจในการหัดอ่านภาษามอญ (လိက်ဂတ်)",
            date: "2025, Aug 30",
            site: "สุชาติ ใจชอบ (သုည ပညါ)",
            link: "https://drive.google.com/file/d/1s1tHwJLEsYIq83_yynf1Oemai0d48D-j/view?usp=sharing"
        },
        {
            name: "Mon alphabet",
            date: "2025, June 9",
            site: "Wikipedia",
            link: "https://en.wikipedia.org/wiki/Mon_alphabet"
        },
        {
            name: "Mon language",
            date: "2025, June 9",
            site: "Wikipedia",
            link: "https://en.wikipedia.org/wiki/Mon_language"
        },
        {
            name: "อักษรมอญ",
            date: "2025, June 9",
            site: "Wikipedia",
            link: "https://th.wikipedia.org/wiki/อักษรมอญ"
        },
        {
            name: "ภาษามอญ",
            date: "2025, June 9",
            site: "Wikipedia",
            link: "https://th.wikipedia.org/wiki/ภาษามอญ"
        },
        {
            name: "คู่มือการเรียนรู้ภาษามอญ (ပြကိုဟ် ပရေင်ကတ်လ္ၚတ်လိက်မန်)",
            date: "2025, June 9",
            site: "FlipHTML5",
            link: "https://online.fliphtml5.com/yjjtg/ejio"
        },
        {
            name: "พจนานุกรมมอญ-ไทย",
            date: "2025, June 9",
            site: "FlipHTML5",
            link: "https://online.fliphtml5.com/yjjtg/bkuu/?1747471532"
        },
        {
            name: "Mon Anonta keyboard",
            date: "2025, June 19",
            site: "Keyman",
            link: "https://keyman.com/keyboards/mon_anonta"
        },
        {
            name: "Abugida",
            date: "2025, July 21",
            site: "Wikipedia",
            link: "https://en.wikipedia.org/wiki/Abugida"
        }
    ],
    technicalsFrontEnd: [
        {
            name: "Vue.js",
            role: "Frontend Framework",
            link: "https://vuejs.org/"
        },
        {
            name: "Vue Router",
            role: "Routing Library for Vue.js",
            link: "https://router.vuejs.org/"
        },
        {
            name: "@Unhead/vue",
            role: "Unhead wraps your document template, improving reactive SSR JavaScript framework SEO and performance.",
            link: "https://unhead.unjs.io/"
        },
        {
            name: "Bootstrap 5.3",
            role: "Bootstrap UI Framework",
            link: "https://getbootstrap.com/docs/5.3/getting-started/introduction/"
        },
        {
            name: "Bootstrap Icons",
            role: "Icon Library for Bootstrap",
            link: "https://icons.getbootstrap.com/"
        },
        {
            name: "simple-keyboard",
            role: "Virtual Keyboard for Vue.js",
            link: "https://www.npmjs.com/package/simple-keyboard"
        },
        {
            name: "Vue Simple Typewriter",
            role: "Typewriter Effect for Vue.js",
            link: "https://www.npmjs.com/package/vue-simple-typewriter"
        },
        {
            name: "vue-audio-player",
            role: "Vue Audio Player Component",
            link: "https://www.npmjs.com/package/@liripeng/vue-audio-player"
        },
        {
            name: "Pyidaungsu Font",
            role: "Official Myanmar Font that supports Mon script by Myanmar Computer Federation.",
            link: "https://mcf.org.mm/pyidaungsu-font/"
        },
        {
            name: "analog-clock-lib",
            role: "A small TypeScript library to render a customizable analog clock using an HTML Canvas element.",
            link: "https://www.npmjs.com/package/analog-clock-lib"
        },
        {
            name: "vue3-scrollama",
            role: "A Vue 3 wrapper for Scrollama, a modern & lightweight JavaScript library for scrollytelling using IntersectionObserver in favor of scroll events.",
            link: "https://www.npmjs.com/package/vue3-scrollama"
        }

    ],
    technicalsBackEnd: [
        {
            name: "MonDictDB",
            role: "Centralized dictionary database of The Mon Language.",
            link: "https://barnista.github.io/MonDictDB/"
        },
        {
            name: "Node.js",
            role: "JavaScript Runtime Environment",
            link: "https://nodejs.org/"
        },
        {
            name: "Firebase",
            role: "Cloud Database, Analytics and Hosting",
            link: "https://firebase.google.com/"
        },
        {
            name: "Tesseract OCR",
            role: "Optical Character Recognition (OCR)",
            link: "https://tesseract-ocr.github.io/"
        },
        {
            name: "Google Cloud Vision API",
            role: "Image Analysis and Text Extraction",
            link: "https://cloud.google.com/vision"
        }
    ]
}